module.exports = ".panel-info {\r\n    border-color: #f5f5f5;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/design-subcategories/design-subcategories.component.css
// module id = ./src/app/modules/dashboard/design-subcategories/design-subcategories.component.css
// module chunks = dashboard.module